
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#0C315E","d":"M25.797 23.5a.354.354 0 00.244-.117l.39-.489a.364.364 0 00.069-.195.354.354 0 00-.117-.244L2.398 3.568a.363.363 0 00-.195-.068.354.354 0 00-.244.117l-.39.489A.364.364 0 001.5 4.3c0 .083.053.192.117.244l23.985 18.887a.364.364 0 00.195.068zm-3.453-5.816a12.997 12.997 0 002.77-3.614 1.5 1.5 0 00.136-.57 1.5 1.5 0 00-.136-.57C22.996 8.797 18.802 6 14 6h-.006c-1.469 0-3.743.498-5.077 1.11l1.788 1.407C11.587 7.739 12.733 7.25 14 7.25a5.01 5.01 0 015 5c0 .845-.23 1.629-.602 2.327l.995.781c.53-.917.857-1.97.857-3.108 0-1.439-.504-2.746-1.32-3.802 1.856.937 4.128 3.2 5.072 5.052-.555 1.077-1.74 2.602-2.647 3.405l.989.779zM14.006 21c1.468 0 3.743-.498 5.077-1.11l-1.143-.899c-1.242.48-2.567.759-3.94.759-4.194 0-8.026-2.395-10-6.25.68-1.328 1.605-2.45 2.668-3.387l-1.01-.796a12.989 12.989 0 00-2.77 3.613 1.5 1.5 0 00-.136.57c0 .166.06.422.135.57C5.004 18.204 9.198 21 14 21h.006zm2.371-8.014c.068-.207.123-.552.123-.77A2.468 2.468 0 0014 9.75c-.04 0-.074.01-.111.011.061.165.111.441.111.617 0 .183-.054.47-.12.64l2.497 1.968zm-2.4 5.514c.755 0 1.925-.257 2.612-.575l-1.156-.91A4.932 4.932 0 0114 17.25a5.01 5.01 0 01-5-5c0-.095.023-.184.028-.278l-1.151-.907a7.26 7.26 0 00-.127 1.185v.024a6.228 6.228 0 006.226 6.226z"}})])
          )
        }
      }
    